import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "actions" }

import { IonAccordion, IonAccordionGroup, IonBadge, IonButton, IonCard, IonCardHeader, IonCardTitle, IonIcon, IonItem, IonLabel, IonSelect, IonSelectOption, popoverController } from '@ionic/vue';
import { translate } from '@hotwax/dxp-components';
import { ellipsisVerticalOutline, timeOutline, timerOutline } from 'ionicons/icons';
import ScheduleActionsPopover from "@/components/ScheduleActionsPopover.vue";
import { computed } from 'vue';
import { getDateAndTime, hasError, showToast } from '@/utils'
import { useStore } from 'vuex';
import logger from '@/logger';
import { RuleService } from '@/services/RuleService';
import { DateTime } from 'luxon';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleRuleItem',
  setup(__props) {

const store = useStore();
const ruleGroup = computed(() => store.getters["rule/getRuleGroup"]);
const isReorderActive = computed(() => store.getters["rule/isReorderActive"]);

const cronExpressions = JSON.parse(process.env?.VUE_APP_CRON_EXPRESSIONS as string)

async function openScheduleActionsPopover(event: Event) {
  const popover = await popoverController.create({
    component: ScheduleActionsPopover,
    showBackdrop: false,
    event
  });

  return popover.present();
}

async function saveSchedule() {
  const payload = {
    ruleGroupId: ruleGroup.value.ruleGroupId,
    paused: 'N',
    ...ruleGroup.value,
    cronExpression: "0 0 0 * * ?",
    // Hardcoding for now, need to fetch system message remote id for the ftp server config.
    systemMessageRemoteId: "RemoteSftp"
  }

  emitter.emit("presentLoader");
  try {
    const resp = await RuleService.scheduleRuleGroup(payload)
    if(!hasError(resp)) {
      showToast(translate("Service has been scheduled."))
      await store.dispatch('rule/fetchRules', { groupTypeEnumId: ruleGroup.value.groupTypeEnumId, pageSize: 50 })
    } else {
      throw resp.data
    }
  } catch(err) {
    showToast(translate("Failed to schedule service."))
    logger.error(err)
  }
  emitter.emit("dismissLoader");
}

function timeTillJob(time: any) {
  if(!time) {
    return;
  }
  const timeDiff = DateTime.fromMillis(time).diff(DateTime.local());
  return DateTime.local().plus(timeDiff).toRelative();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonAccordionGroup), { value: isReorderActive.value }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordion), { value: "false" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            slot: "header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($event.stopImmediatePropagation()))
          }),
          _createVNode(_unref(IonCard), { slot: "content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("Schedule")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonBadge), {
                    color: ruleGroup.value.schedule?.paused === 'Y' ? 'warning' : 'dark'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(ruleGroup.value.schedule?.paused === "Y" ? _unref(translate)("Paused") : timeTillJob(ruleGroup.value.schedule?.nextExecutionDateTime)), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "start",
                    icon: _unref(timeOutline)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("Run time")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonLabel), { slot: "end" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(ruleGroup.value.schedule?.paused === 'N' ? _unref(getDateAndTime)(ruleGroup.value.schedule?.nextExecutionDateTime) : "-"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonItem), { lines: "full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "start",
                    icon: _unref(timerOutline)
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(IonSelect), {
                    label: _unref(translate)('Schedule'),
                    interface: "popover",
                    placeholder: _unref(translate)('Select'),
                    value: "0 0 0 * * ?",
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cronExpressions), (expression, description) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          key: expression,
                          value: expression
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(description), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["label", "placeholder"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(IonButton), {
                  fill: "clear",
                  disabled: ruleGroup.value.schedule?.paused === 'N',
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (saveSchedule()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Schedule")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(IonButton), {
                  color: "medium",
                  fill: "clear",
                  slot: "end",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openScheduleActionsPopover($event)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(ellipsisVerticalOutline),
                      slot: "icon-only"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})